// share-providers/copy.js
import { showNotification } from "aldoo-ra/Notification"
import Localization from "aldoo-ra/Localization"

export const copyContent = async (url, message) => {

  try {
    await navigator.clipboard.writeText(url)
    showNotification({
      message,
      className: "bg-primary text-text",
    })
    return true
  } catch (err) {
    console.error("Failed to copy: ", err)
    return false
  }
}
